export const isDictionaryEmpty = (dict) => Object.keys(dict).length === 0;
